<template>
    <div class="user-panel d-flex">
        <div class="loggedIn user" @click="detailbox = !detailbox">
            <div class="user-text">{{ session.wallet | toMoney(session.currency) }}</div>
        </div>
        <div class="loggedIn myBets">
            <router-link :to="{name: 'my_bets'}" tag="div" class="mybets-text">{{t.navigation.my_bets}}</router-link>
        </div>
        <div class="loggedIn deposit">
            <router-link :to="{name: 'my_payments'}" tag="div" class="deposit-text">{{t.deposit_now}}</router-link>
        </div>
        <div class="user-detail-box" v-if="detailbox">
            <ul>
                <li class="user-details">
                    <div>{{session.username}}</div>
                    <span class="balance-sport">Bakiye : {{ session.wallet | toMoney(session.currency) }}</span>
                    <span class="balance-sport">{{t.credit}} : {{ session.credit | toMoney(session.currency) }}</span>
                    <span class="balance-sport">{{t.bonus}} : {{ session.bonus | toMoney(session.currency) }}</span>
                </li>
                <li class="account-link">
                    <router-link :to="{name: 'bank_accounts'}" tag="a">Hesap Özeti</router-link>
                </li>
                <li class="deposit-link">
                    <router-link :to="{name: 'my_payments'}" tag="a" class="orange">{{t.deposit_now}}</router-link>
                </li>
                <li class="withdraw-link">
                    <router-link :to="{name: 'my_payments'}" tag="a">{{t.wıthdraw_now}}</router-link>
                </li>
                <li class="personal-link">
                    <router-link :to="{name: 'personal_informations'}" tag="a">{{t.navigation.personal_informations}}</router-link>
                </li>
                <li class="mybets-link">
                    <router-link :to="{name: 'my_bets'}" tag="a">{{t.navigation.my_bets}}</router-link>
                </li>
                <li class="messages-link">
                    <router-link :to="{name: 'messages'}" tag="a">Mesajlar</router-link>
                </li>
                <li class="bonus-link">
                  <a>Bonus ve ücretsiz bahisler</a>
                </li>
                <li class="document-link">
                    <a>Belge Tükle</a>
                </li>
                <li class="security-link">
                    <router-link :to="{name: 'change_password'}" tag="a">Şifre ve Güvenlik</router-link>
                </li>
                <li class="logout-link" @click="logout()">
                    <a>{{t.logout}}</a>
                </li>
                <li class="lastlogin-link">
                    <a>{{t.user.last_login}}: </a>
                </li>
            </ul>
        </div>
    </div>

</template>

<script>
    import ProfilePic from '@/components/user/ProfilePic'
    import Notifications from '@/components/user/account/notifications'

    export default {
        name: 'userPanel',
        components: {ProfilePic, Notifications},
        data() {
            return {
                session: session,
                t: this.$root.t,
                showN: false,
                detailbox: false,
            }
        },
        mounted() {
            this.$bus.$on('sessionUpdated', (payload) => {
                self.session = null
                setTimeout(() => {
                    self.session = window.session;
                }, 500);
            });
            this.$bus.$on('betCreated', (payload) => {
                self.$bus.$emit('sessionUpdated', true);
            });
        },
        methods: {
            showNotifications() {
                this.showN = true;
            },
            logout () {
                this.$setItem('auth', {});

                setTimeout(() => {
                    window.location.href = '/';
                }, 500);
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .buttons a i:before {
        font-size: 18px
    }

    .user-panel {
        float: right;
        list-style: none;
        width: 100%;
        position: relative;
        z-index: 100;
    }

    .wallet, .user {
        width: 160px;
    }

    .reload-balance {
        color: #eee;
    }

    .user-panel .bx {
        border-radius: 5px;
        border: 2px solid #00f4ff;
    }

    .user-panel .bx:hover {
        box-shadow: inset 0 1px 1px rgba(111, 55, 125, 0.8), inset 0 -1px 0px rgba(63, 59, 113, 0.2), 0 9px 16px 0 rgba(0, 0, 0, 0.3), 0 4px 3px 0 rgba(0, 0, 0, 0.3), 0 0 0 1px #150a1e;
        background: #00f4ff;
        color: #ff7f00;
    }

    .user-drodown {
        display: none;
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .wallet {
        color: yellow !important;
        border-radius: 4px 0 0 4px !important;
    }

    /*.user {
        background: #00f4ff;
        border-radius: 0 4px 4px 0 !important;
    }*/

    .n-ico > a {
        color: #00f4ff;
    }

    .n-ico {
        width: 25px;
    }

    .n-ico:hover {
        background: #fff;
    }

    .notify-content {
        color: #000;
        font-size: 12px;
        width: 280px;
        height: 280px;
        border-radius: 4px;
        overflow-y: auto;
        display: none;
        position: relative;
        z-index: 5;

        box-shadow: inset 0 1px 1px rgba(111, 55, 125, 0.8), inset 0 -1px 0px rgba(63, 59, 113, 0.2), 0 9px 16px 0 rgba(0, 0, 0, 0.3), 0 4px 3px 0 rgba(0, 0, 0, 0.3), 0 0 0 1px #150a1e;
        background: #00f4ff;
    }

    .notify-content a {
        color: #323b57 !important;
    }

    .notify-content .header-c {

        height: 45px;
    }

    .notify-content .header-c h4 {
        font-size: 16px;
        line-height: 25px;
    }

    .n-ico:hover .notify-content {
        display: block;
    }

    .total-count {
        font-size: 12px;
        color: white;
        background: red;
        width: 20px;
        height: 20px;
        line-height: 18px;
        border-radius: 5px;
        position: absolute;
        top: -10px;
        right: -10px;
    }

    .bonus-amount {
        color: red !important
    }

    .loggedIn {
        flex: 1 0 33.3%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .user .user-text, .myBets .mybets-text, .deposit .deposit-text {
        white-space: nowrap;
        padding-top: 25px;
        line-height: 10px;
        cursor: pointer;
        font-size: 10px;
    }

    .deposit {
        background: #f64835;
    }

    .deposit .deposit-text {
        border-radius: 0;
        background: url("/static/assets/img/payin_header_white.png") no-repeat center top 5px;
        background-size: 16px 16px;
        color: #fff;
    }

    .myBets .mybets-text {
        border-radius: 0;
        background: url("/static/assets/img/rivalo/mybets-black-icon.png") no-repeat center top 5px;
        background-size: 16px 16px;
    }

    .myBets .mybets-text {
        border-radius: 0;
        background: url("/static/assets/img/rivalo/mybets-black-icon.png") no-repeat center top 5px;
        background-size: 16px 16px;
    }

    .user .user-text {
        border-radius: 0;
        background: url("/static/assets/img/rivalo/dark-user-icon.png") no-repeat center top 5px;
        background-size: 16px 16px;
    }

    .user-detail-box {
        position: absolute;
        top: 55px;
        background: linear-gradient(to bottom, #d8e8f0 -1%, #ffffff 9%, #ffffff 65%);
        width: 180px;
        right: 78px;
        box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.4);
        padding: 5px;
        border-bottom: 3px solid #7c7c7c;
    }

    .user-detail-box:before {
        content: '';
        position: absolute;
        left: 70px;
        top: -10px;
        border-style: solid;
        border-width: 0 15px 10px 15px;;
        border-color: transparent transparent #f64835 transparent;
    }

    .user-detail-box li {
        list-style-type: none;
        padding: 0 10px;
        margin: 0;
        cursor: pointer;
        border-bottom: 1px solid #f2f2f6;
    }

    .user-detail-box ul {
        padding: 0 !important;
        margin: 0 !important;
    }

    .user-detail-box {
        padding: 0;
        margin: 0;
    }

    li.user-details {
        color: #fff;
        padding-left: 40px;
        position: relative;
        font-size: 13px;
        padding-top: 5px;
        overflow: hidden;
        background: #f64835;
        text-overflow: ellipsis;
    }

    li.user-details:before {
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        display: block;
        width: 40px;
        height: 34px;
        background: url("/static/assets/img/rivalo/blue-user-icon.png") no-repeat center;
        background-size: 20px;
    }

    li.user-details div {
        line-height: 16px;
        margin-bottom: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    li.user-details span {
        display: block;
        font-size: 10px;
    }

    .user-detail-box li a {
        min-height: 34px;
        position: relative;
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: flex;
        align-items: center;
        color: #000;
        background-size: 20px;
        padding-left: 30px;
    }

    .user-detail-box li a:hover, .user-detail-box li a.orange {
        color: #ef8107;
    }

    .user-detail-box .account-link a {
        background: url("/static/assets/img/rivalo/account-icon.png") no-repeat left center;
    }

    .user-detail-box .deposit-link a, .user-detail-box .withdraw-link a {
        background: url("/static/assets/img/rivalo/deposit-black-icon.png") no-repeat left center;
    }

    .user-detail-box .personal-link a {
        background: url("/static/assets/img/rivalo/personal-detail-icon.png") no-repeat left center;
    }

    .user-detail-box .mybets-link a {
        background: url("/static/assets/img/rivalo/mybets-black-icon.png") no-repeat left center;
    }

    .user-detail-box .messages-link a {
        background: url("/static/assets/img/rivalo/messages-icon.png") no-repeat left center;
    }

    .user-detail-box .bonus-link a {
        background: url("/static/assets/img/rivalo/bonus-icon.png") no-repeat left center;
        background-size: 20px !important;
    }

    .user-detail-box .document-link a {
        background: url("/static/assets/img/rivalo/upload-icon.png") no-repeat left center;
    }

    .user-detail-box .security-link a {
        background: url("/static/assets/img/rivalo/security-icon.png") no-repeat left center;
    }

    .user-detail-box .logout-link a {
        background: url("/static/assets/img/rivalo/logout-icon.png") no-repeat left center;
    }

    .user-detail-box .lastlogin-link a {
        text-align: center;
    }

</style>



// WEBPACK FOOTER //
// src/components/user/top/UserPanel.vue